(function () {
    const asideMenu = document.getElementById('f19-aside-menu');
    const asideToggle = document.getElementById('f19-mobile-aside-toggle');

    if (asideMenu){
        const nestedListItems = asideMenu.querySelectorAll('nav > ul > li');

        if(nestedListItems){
            for (let i = 0; i < nestedListItems.length; i++) {
                if(nestedListItems[i].getElementsByTagName('ul').length > 0){
                    nestedListItems[i].classList.add('has-ul');
                }
            }
        }
    }
    
    const mediaQuery = window.matchMedia("(max-width: 1024px)")
    
    if (asideMenu || asideToggle) {
        if (mediaQuery.matches) {
            asideToggle.addEventListener('click', toggleAsideMenu)

            function toggleAsideMenu(event) {
                event.preventDefault()

                if (!asideMenu.classList.contains('collapsed')) {
                    asideMenu.classList.add('collapsed');

                    document.querySelector('body').classList.remove('overflow-hidden');

                } else {
                    asideMenu.classList.remove('collapsed');
                    document.querySelector('body').classList.add('overflow-hidden');
                }
            }
        } else {
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    }

    //Check if list element has children other than list items
    const unorderedLists = document.querySelectorAll('article > .f19-unordered-list');
    const orderedLists = document.querySelectorAll('article > .f19-ordered-list');

    for (let i = 0; i < unorderedLists.length; i++) {
        if (unorderedLists[i].querySelector('.f19-image') ||
            unorderedLists[i].querySelector('.f19-iframe-container') ||
            unorderedLists[i].querySelector('.f19-group') ||
            unorderedLists[i].querySelector('.f19-hero') ||
            unorderedLists[i].querySelector('.f19-blockquote') ||
            unorderedLists[i].querySelector('.f19-unordered-list')) {

            unorderedLists[i].classList.add('list-style-none')
        }
    }
    for (let i = 0; i < orderedLists.length; i++) {
        if (orderedLists[i].querySelector('.f19-image') ||
            orderedLists[i].querySelector('.f19-iframe-container') ||
            orderedLists[i].querySelector('.f19-group') ||
            orderedLists[i].querySelector('.f19-hero') ||
            orderedLists[i].querySelector('.f19-blockquote') ||
            orderedLists[i].querySelector('.f19-unordered-list')) {

            orderedLists[i].classList.add('list-style-none')
        }
    }

    let prevScrollPos = window.pageYOffset;
    const f19AsideMenu = document.getElementById('f19-aside-menu');

    if (f19AsideMenu) {
        if (mediaQuery.matches) {
            function headerScroll() {
                let currentScrollPos = window.pageYOffset;

                const content = document.createElement('body');

                var scrolled = document.scrollingElement.scrollTop;
                var position = content.offsetTop;

                if (scrolled > position + 15) {
                    if (!f19AsideMenu.classList.contains('org-header--active')) {
                        if (prevScrollPos <= currentScrollPos) {
                            f19AsideMenu.style.top = '-9rem';
                        } else {
                            f19AsideMenu.style.backgroundColor = 'white';
                            f19AsideMenu.style.borderBottom = '1px solid #d8d8d8';

                            f19AsideMenu.style.top = '6rem';
                        }
                    }
                } else if (scrolled < position + 5) {
                    f19AsideMenu.style.backgroundColor = '';
                    f19AsideMenu.style.borderBottom = '';
                }

                prevScrollPos = currentScrollPos;
            }

            $(window).on('scroll', function () {
                headerScroll();
            });
        }
    }
	
	$(".f19-add-cart").click(function (e) {		
		const articleId = $(this).data("article-id");
		const addedMessage = $(this).data("article-added");
		const cookieValue = document.cookie.split("; ").find((row) => row.startsWith("f19-cart="))?.split("=")[1];
		let cart = [];
		
		if (cookieValue) {
			cart = cookieValue.split("|").map(Number);
		}
		
		if (!cart.includes(articleId)) {
			cart.push(articleId);
		    document.cookie = "f19-cart=" + cart.join("|") + "; expires=Fri, 31 Dec " + (new Date().getFullYear() + 1) + " 23:59:59 GMT; path=/; SameSite=Strict; Secure";
		}

        $(this).addClass('added')
        $(this).removeClass('icon-left');
		$(this).text(addedMessage);
	});
	
	$(".f19-delete-article").click(function (e){
		e.preventDefault();

		const articleId = $(this).data("article-id");
		const cookieValue = document.cookie.split("; ").find((row) => row.startsWith("f19-cart="))?.split("=")[1];
		let cart = [];
		
		if (cookieValue) {
			cart = cookieValue.split("|").map(Number);
		}

		if (cart.includes(articleId)) {
		    document.cookie = "f19-cart=" + cart.filter((item) => item !== articleId).join("|") + "; expires=Fri, 31 Dec " + (new Date().getFullYear() + 1) + " 23:59:59 GMT; path=/; SameSite=Strict; Secure";
		}
		
		// Remove element from form or the whole form if there are no more items in the cart	
		console.log("Siblings: " + $(this).parent().siblings().length);
		if ($(this).parent().siblings().length === 0) {
			$(this).closest("form").remove();
		} else {
			$(this).parent().remove();
		}
	});
	
	$(".f19 button[data-busy]").click(function () {
		$(this).prop("enabled", false).addClass("added").find('.text').text($(this).data("busy"));
        $(this).find('.atm-icon').removeClass("fa-arrow-down-to-line").addClass("fa-spinner fa-spin-pulse");

	});
})();